import { Injectable, HostListener, Inject } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { WINDOW } from "./windows.service";
// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	rol?: string;
	moduleKey?: string;
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false

	constructor(@Inject(WINDOW) private window) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener("window:resize", ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	/* MENUITEMS: Menu[] = [
		{
			path: '/dashboard/default', title: 'Dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Products', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Physical', type: 'sub', children: [
						{ path: '/products/physical/category', title: 'Category', type: 'link' },
						{ path: '/products/physical/sub-category', title: 'Sub Category', type: 'link' },
						{ path: '/products/physical/product-list', title: 'Product List', type: 'link' },
						{ path: '/products/physical/product-detail', title: 'Product Detail', type: 'link' },
						{ path: '/products/physical/add-product', title: 'Add Product', type: 'link' },
					]
				},
				{
					title: 'digital', type: 'sub', children: [
						{ path: '/products/digital/digital-category', title: 'Category', type: 'link' },
						{ path: '/products/digital/digital-sub-category', title: 'Sub Category', type: 'link' },
						{ path: '/products/digital/digital-product-list', title: 'Product List', type: 'link' },
						{ path: '/products/digital/digital-add-product', title: 'Add Product', type: 'link' },
					]
				},
			]
		},
		{
			title: 'Sales', icon: 'dollar-sign', type: 'sub', active: false, children: [
				{ path: '/sales/orders', title: 'Orders', type: 'link' },
				{ path: '/sales/transactions', title: 'Transactions', type: 'link' },
			]
		},
		{
			title: 'Coupons', icon: 'tag', type: 'sub', active: false, children: [
				{ path: '/coupons/list-coupons', title: 'List Coupons', type: 'link' },
				{ path: '/coupons/create-coupons', title: 'Create Coupons', type: 'link' },
			]
		},
		{
			title: 'Pages', icon: 'clipboard', type: 'sub', active: false, children: [
				{ path: '/pages/list-page', title: 'List Page', type: 'link' },
				{ path: '/pages/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Media', path: '/media', icon: 'camera', type: 'link', active: false
		},
		{
			title: 'Menus', icon: 'align-left', type: 'sub', active: false, children: [
				{ path: '/menus/list-menu', title: 'Menu Lists', type: 'link' },
				{ path: '/menus/create-menu', title: 'Create Menu', type: 'link' },
			]
		},
		{
			title: 'Users', icon: 'user-plus', type: 'sub', active: false, children: [
				{ path: '/users/list-user', title: 'User List', type: 'link' },
				{ path: '/users/create-user', title: 'Create User', type: 'link' },
			]
		},
		{
			title: 'Vendors', icon: 'users', type: 'sub', active: false, children: [
				{ path: '/vendors/list-vendors', title: 'Vendor List', type: 'link' },
				{ path: '/vendors/create-vendors', title: 'Create Vendor', type: 'link' },
			]
		},
		{
			title: 'Localization', icon: 'chrome', type: 'sub', children: [
				{ path: '/localization/translations', title: 'Translations', type: 'link' },
				{ path: '/localization/currency-rates', title: 'Currency Rates', type: 'link' },
				{ path: '/localization/taxes', title: 'Taxes', type: 'link' },
			]
		},
		{
			title: 'Reports', path: '/reports', icon: 'bar-chart', type: 'link', active: false
		},
		{
			title: 'Settings', icon: 'settings', type: 'sub', children: [
				{ path: '/settings/profile', title: 'Profile', type: 'link' },
			]
		},
		{
			title: 'Invoice', path: '/invoice', icon: 'archive', type: 'link', active: false
		},
		{
			title: 'Login',path: '/auth/sign-in', icon: 'log-in', type: 'link', active: false
		}
	] */

	MENUITEMS: Menu[] = [
		{
			path: '/inicio', title: 'Inicio', icon: 'home', type: 'link', active: false, rol: 'teacher, collaborator, student'
		},

	// ── Perfil: Administrador (admin) ─────────────────────────────────────
	{
		path: '/inicio', title: 'Inicio', icon: 'home', type: 'link', active: false, rol: 'admin'
	},
	{
		path: '/dashboard', title: 'Dashboard', icon: 'bar-chart-2', type: 'link', active: false, rol: 'admin'
	},
		{
			path: '/users/consulta', title: 'Usuarios', rol: 'admin', icon: 'users', type: 'link', active: false
		},
		{
			title: 'Suscripciones', rol: 'admin', icon: 'credit-card', type: 'sub', active: false, children: [
				{ path: '/suscripciones', title: 'Cuentas', type: 'link' },
				{ path: '/suscripciones/planes', title: 'Planes', type: 'link' },
				{ path: '/suscripciones/modulos', title: 'Módulos', type: 'link' },
			]
		},
		{
			path: '/Ventas', title: 'Ventas', rol: 'admin', icon: 'shopping-cart', type: 'link', active: false
		},
		{
			title: 'Productos', rol: 'admin', icon: 'shield-off', type: 'sub', active: false, children: [
				{ path: '/products/courses', title: 'Cursos', type: 'link' },
				{ path: '/products/ebooks', title: 'Ebooks', type: 'link' },
				{ path: '/products/capacitations', title: 'Capacitaciones', type: 'link' },
				{ path: '/products/webinars', title: 'Webinars', type: 'link' },
				{ path: '/products/events', title: 'Eventos', type: 'link' },
				{ path: '/products/catalogs', title: 'Catálogos', type: 'link' },
			]
		},
		{
			title: 'Productos', rol: 'teacher', icon: 'list', type: 'sub', active: false, children: [
				{ path: '/products/courses', title: 'Mis cursos', type: 'link' },
				{ path: '/products/ebooks', title: 'Ebooks', type: 'link' },
			]
		},
		{
			// ✅ REPOSICIONADO: Videoteca como menú principal con submenús (antes estaba al final)
			title: 'Videoteca', rol: 'teacher, collaborator', icon: 'video', type: 'sub', active: false, children: [
				{ path: '/Videoteca', title: 'Mi Videoteca', type: 'link' },
				{ path: '/Colaboradores', title: 'Colaboradores', type: 'link' }
			]
		},
		{
			path: '/contactos', title: 'Contactos', rol: 'teacher', icon: 'users', type: 'link', active: false
		},
	// Menú específico para estudiantes - solo Inicio y Videoteca (solo lectura)
	{
		path: '/Videoteca', rol: 'student', icon: 'video', title: 'Videoteca', type: 'link', active: false
	},

	// ── Modo: Cliente (user) ──────────────────────────────────────────────────
	{
		path: '/inicio', title: 'Inicio', icon: 'home', type: 'link', active: false, rol: 'user'
	},
	{
		path: '/students', title: 'Mis cursos', icon: 'book-open', type: 'link', active: false, rol: 'user'
	},
	{
		path: '/Ventas/orders', title: 'Mis compras', icon: 'shopping-bag', type: 'link', active: false, rol: 'user'
	},

	// ── Modo: Negocio (business) ──────────────────────────────────────────────
	{
		path: '/inicio', title: 'Inicio', icon: 'home', type: 'link', active: false, rol: 'business', moduleKey: 'dashboard'
	},
	{
		path: '/launchpad', title: 'Launchpad', icon: 'zap', type: 'link', active: false, rol: 'business', badgeType: 'launchpad'
	},

	// ── Sección: Productos y servicios ───────────────────────────────────────
	{ type: 'section', title: 'Productos y servicios', rol: 'business' },
	{
		path: '/products/courses', title: 'Mis cursos', icon: 'book-open', type: 'link', active: false, rol: 'business', moduleKey: 'content.courses'
	},
	{
		path: '/products/ebooks', title: 'Mis ebooks', icon: 'book', type: 'link', active: false, rol: 'business', moduleKey: 'content.ebooks'
	},

	// ── Sección: CRM ─────────────────────────────────────────────────────────
	{ type: 'section', title: 'CRM', rol: 'business' },
	{
		path: '/contactos', title: 'Contactos', icon: 'users', type: 'link', active: false, rol: 'business', moduleKey: 'crm.leads'
	},
	{
		path: '/conversaciones', title: 'Conversaciones', icon: 'message-circle', type: 'link', active: false, rol: 'business', moduleKey: 'crm.leads'
	},
	{
		path: '/pipelines', title: 'Oportunidades', icon: 'trending-up', type: 'link', active: false, rol: 'business', moduleKey: 'crm.leads'
	},
	{
		path: '/calendario', title: 'Calendario', icon: 'calendar', type: 'link', active: false, rol: 'business', moduleKey: 'appointments'
	},

	// ── Sección: Herramientas ────────────────────────────────────────────────
	{ type: 'section', title: 'Herramientas', rol: 'business' },
	{
		path: '/Videoteca', title: 'Videoteca', icon: 'video', type: 'link', active: false, rol: 'business', moduleKey: 'videoteca'
	},
	{
		path: '/Email-Marketing', title: 'Email marketing', icon: 'mail', type: 'link', active: false, rol: 'business', moduleKey: 'email_marketing'
	},
	{
		path: '/landing-pages', title: 'Landing pages', icon: 'layout', type: 'link', active: false, rol: 'business', moduleKey: 'landing_pages'
	},
	{
		path: '/social-media', title: 'Redes sociales', icon: 'share-2', type: 'link', active: false, rol: 'business', moduleKey: 'social_media'
	},

	// ── Sección: Mi equipo ───────────────────────────────────────────────────
	{ type: 'section', title: 'Mi equipo', rol: 'business' },
	{
		path: '/equipo/usuarios', title: 'Usuarios', icon: 'users', type: 'link', active: false, rol: 'business'
	},
	{
		path: '/equipo/perfiles', title: 'Perfiles', icon: 'shield', type: 'link', active: false, rol: 'business'
	},

	// ── Sección: Administración ──────────────────────────────────────────────
	{ type: 'section', title: 'Administración', rol: 'business' },
	{
		path: '/negocio/ventas', title: 'Ventas', icon: 'shopping-cart', type: 'link', active: false, rol: 'business', moduleKey: 'administration.sales'
	},
	{
		path: '/negocio/pagos', title: 'Cobranza', icon: 'credit-card', type: 'link', active: false, rol: 'business', moduleKey: 'administration.payments'
	},

	// ── Modo: Embajador (ambassador) ─────────────────────────────────────────
	{
		path: '/inicio', title: 'Inicio', icon: 'home', type: 'link', active: false, rol: 'ambassador'
	},
	{
		path: '/contactos', title: 'Mis afiliados', icon: 'users', type: 'link', active: false, rol: 'ambassador'
	},
	{
		path: '/enlaces', title: 'Invitaciones', icon: 'link', type: 'link', active: false, rol: 'ambassador'
	},
	{
		path: '/contactos/settings', title: 'Configuración CRM', rol: 'ambassador', icon: 'settings', type: 'link', active: false
	},
]

	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
